import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux";
import { updateError } from "../../../redux/reducer/surveyReportReducer";
import { getErrorMessage } from "../../../utils/helpers";
import ButtonHeader from "../../../components/common/buttonHeader";
import ButtonSubmit from "../../../components/common/buttonSubmit";
import ErrorAlertMessage from "../../../components/alertMessageModal/ErrorAlertMessage";
import Header from "../../../components/header";
import SurveyFilterTable from "../../../components/survey/surveyFilterTable";
import SurveyFilterForm from "../../../components/survey/surveyFilterForm";

// Component starts
const FarmaciaSurveyReport = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  /**
   * Get url params.
   */
  const location = useLocation();
  const { name, region } = location.state || {};

  /**
   * redux hooks.
   */
  const { user } = useSelector((state: any) => state.login);
  const { surveysReport } = useSelector((state: any) => state);
  const { apiError } = surveysReport;

  /**
   * update notificationType value
   */
  const handleClose = () => {
    dispatch(updateError());
  };

  return (
    <>
      {apiError?.key && (
        <ErrorAlertMessage
          icon="info"
          handleClose={handleClose}
          message={
            apiError?.key ? getErrorMessage(apiError) : t("survey-report-error")
          }
        />
      )}
      <Header active={true} titleLogOut={user?.username} />
      {/* render back button and page headline title */}
      <div className="container-box d-flex align-items-center col-lg-12 mb-4">
        <div className="col-lg-4">
          <div className="d-inline">
            <ButtonHeader
              className="btn btnHeader d-flex align-items-center"
              handleChange={() => navigate("/surveys")}
              icon="chevron_left"
              textButton={t("go-back")}
            />
          </div>
        </div>
        <div className="page-title col-lg-4">
          <h1 className="mb-0">{t("headerSection.report")}</h1>
        </div>
        <div className="col-lg-4"></div>
      </div>

      {/* display farmacia details - header row section */}
      <div className="container-box mb-3">
        <div className="content info-content">
          <div className="page-title d-flex align-items-center justify-content-between">
            <h2>{name}</h2>
          </div>
          <ButtonSubmit
            spinner={false}
            textButton={t("pharmacy-detail")}
            handleChange={() =>
              navigate(`/surveys/farmacia/view`, {
                state: {
                  region: region,
                  name: name,
                },
              })
            }
          />
        </div>
      </div>

      <SurveyFilterForm isAdminUser={false} region={region} />
      <SurveyFilterTable />
    </>
  );
};

export default FarmaciaSurveyReport;
